var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarVisual = function SvgCarVisual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.947 43.22v-2.702a2 2 0 0 1 2.862-1.805l5.661 2.703c1.923.918 1.269 3.805-.861 3.805h-5.662a2 2 0 0 1-2-2ZM64.254 43.22v-2.702a2 2 0 0 0-2.862-1.805l-5.661 2.703c-1.922.918-1.269 3.805.862 3.805h5.66a2 2 0 0 0 2-2ZM9.43 53.716v6.78a3 3 0 0 0 3 3h5.557a3 3 0 0 0 3-3v-1.613M70.708 53.716v6.78a3 3 0 0 1-3 3h-5.557a3 3 0 0 1-3-3v-1.567M14.086 24.535l.916 1.207c1 1.317.06 3.209-1.594 3.209H7.612a2 2 0 0 1-2-2v-1.207a2 2 0 0 1 2-2h4.881a2 2 0 0 1 1.594.79ZM65.914 24.535l-.916 1.207c-1 1.317-.06 3.209 1.593 3.209h5.798a2 2 0 0 0 2-2v-1.207a2 2 0 0 0-2-2h-4.882a2 2 0 0 0-1.593.79Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 16.505H24.827a2 2 0 0 0-1.746 1.025L15.948 30.3a2 2 0 0 1-.427.528l-6.299 5.526a2 2 0 0 0-.681 1.503v13.459a2 2 0 0 0 1.132 1.801L22.1 59.106a2 2 0 0 0 .868.198H48.8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1 16.505h15.21a2 2 0 0 1 1.746 1.025L64.189 30.3a2 2 0 0 0 .428.528l6.298 5.526a2 2 0 0 1 .682 1.503v13.459a2 2 0 0 1-1.132 1.801l-12.427 5.988a2 2 0 0 1-.868.198H31.338M15.947 28.95h46.615",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.023 45.22h11.142c.344 0 .681.09.98.258l3.235 1.82c.3.167.637.256.981.256h3.754",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.504 45.22H47.36a2 2 0 0 0-.98.258l-3.235 1.82a2 2 0 0 1-.98.256h-3.754",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
export default SvgCarVisual;